/**
 * Rule that checks whether an isolated element exists
 */
const { is } = require("bpmnlint-utils");

module.exports = function noIsolatedFlowNodes() {
  return {
    check(node, reporter) {
      if (!node) return;

      if (!is(node, "bpmn:FlowNode")) return;

      const bo = node.businessObject || node;
      if (bo.$type === "bpmn:BoundaryEvent" && bo.attachedToRef) {
        return;
      }

      const incoming = Array.isArray(node.incoming) ? node.incoming : [];
      const outgoing = Array.isArray(node.outgoing) ? node.outgoing : [];

      if (incoming.length === 0 && outgoing.length === 0) {
        reporter.report(node.id, "This element is not connected to any other element.");
      }
    }
  };
};
